import _ from "lodash";
/**-- external -- */
import React from "react";
import moment from "moment";

import {
  Announcements3D,
  AttendanceManager3D,
  Calendar3D,
  ClassroomReview3D,
  FamilyCommunication3D,
  ProgressReport3D,
  IbPolicy3D,
  IbAandE3D,
  ClipboardList3D,
  School3D,
  Workbook3D,
  Journal3D,
  Goals3D,
  Analytics3D,
  HeadHeart3D,
  BookStackVertical3D,
  Link3D,
  Timetable3D,
  StaffPermissions3D,
  Sync3D,
  PlanningInsights3D,
  BookSpiralGrade3D,
  StudentGuidance3D,
  Notes3D,
  CardUnit3D,
  Document3D,
} from "@toddle-edu/ds-icons";

/**-- internal --*/
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
} from "Constants/stringConstants";
import ACLStorage from "lib/aclService";
import ACLStore from "lib/aclStore";
import { CURRICULUM_TYPE_ORDER_MAPPING } from "Constants";
import { HOMEPAGE_WIDGETS_BE_KEYS } from "HomePage/modules/HomePageConstants";
import {
  EDUCATOR_CENTER_REVAMP,
  ENABLE_BEHAVIOUR_MODULE_PERM,
  PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  SNPv2_ACCESS_PERMISSION,
  SNPv2_MANAGE_EVALUATION_CYCLES_PERMISSION,
  ATTENDANCE_DASHBOARD_ACCESS_PERMISSION,
  HOMEROOM_ACCESS_PERMISSION,
  VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,
  CAN_VIEW_ANNOUNCEMENT_MODULE,
  CAN_VIEW_CALENDAR_MODULE_SETTING,
  ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
  COMBINE_CURRICULUM_HOME_PAGE_PERMISSION,
  ADMIN_GRADEBOOK_ACCESS_PERMISSION,
  TIMETABLE_MANAGER_ACCESS_PERMISSION,
  PLANNING_INSIGHTS_PROGRAMME_LEVEL_VIEW_PERMISSION,
  STATIC_WIDGETISED_SCHOOL_HOMEPAGE,
  SCHOOL_HOMEPAGE_HIDDEN_MODULES_AND_PROJECTS,
  SCHOOL_HOMEPAGE_MODULES_AND_PROJECTS_ORDER,
} from "Constants/permissionConstants";

import { getSubLabel } from "modules/Services/ServicesUtils";
import {
  getHomepageFeatureVisibilityStatus,
  checkIsHomepageWidgetEnabled,
} from "HomePage/modules/HomePageUtils";

import { canViewStudentGoals } from "Teacher/routes/StudentGoals/modules/Utils";

import { getSettingValue } from "modules/PermissionModule";
import { getUserInfo } from "Login/modules/LoginModule";
import {
  getClassRoomTodoText,
  mapleBearLikeCentralOrg,
  rolesAndPermissionsShowMessagingCard,
  isMapleBearLikeEducator,
  isTimetableWidgetEnabled,
  isLtiServiceAvailable,
  shouldShowRegionTags,
  getUserRegions,
} from "Courses/modules/utils";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";

import {
  MODULES,
  getAccessLevels,
  RULE_OPTIONS,
  hasModuleAdminAccess,
} from "lib/staffPermissionUtils";

import { isSchoolLibraryEnabled } from "SchoolLibrary/modules/Utils";
import { isCurriculumInsightsEnabled } from "CurriculumInsights/modules/Utils";
import { isMessagingV2Enabled } from "MessagingV2/modules/Utils";
import { getIsCurriculumMapsEnabled } from "CurriculumMaps/modules/Utils";

import { isToddleAnalyticsEnabled } from "ToddleAnalytics/modules/Utils";
import { getIsRnpConsumptionAllowed } from "Administrator/routes/AttendanceDashboard/modules/Utils";
import {
  getIsMcGrawHillLTIToolEnabled,
  isSentralPortalFeatureEnabled,
  getIsNewAdminUIEnabled,
} from "Utils/ACLStoreUtils";
import { recordEvent } from "lib/eventTracker";
import { getMemoizedLangFunction, getMbRegionLocalizedKey } from "Utils";
import { getLTIName } from "LTIComponent/modules/Utils";

/*-- relative --*/
import {
  getHomeroomStudentsCount,
  getNewSnPCyclesCount,
  getOauthServiceName,
} from "./module/GraphqlHelpers";

import styles from "./TeacherCoursesStyles";
import { getUserCurriculumPrograms } from "modules/CommonSelectors";
import {
  HOME_PAGE_FEATURE_ANNOUNCEMENT,
  HOME_PAGE_FEATURE_CALENDAR,
  HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
  HOME_PAGE_FEATURE_MESSAGING,
  HOME_PAGE_FEATURE_PROGRESS_REPORT,
  HOME_PAGE_FEATURE_ATTENDANCE,
  HOME_PAGE_FEATURE_CLASSROOM_TODO,
  HOME_PAGE_FEATURE_GOALS,
  HOME_PAGE_FEATURE_TIMETABLE,
  HOME_PAGE_FEATURE_TIMETABLE_MANAGER,
  HOME_PAGE_FEATURE_COURSES,
  HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_MB_LIBRARY,
  HOME_PAGE_FEATURE_HOMEROOM,
  HOME_PAGE_FEATURE_DP_SUBJECT_CENTER,
  HOME_PAGE_FEATURE_TODDLE_ANALYTICS,
  HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_MB_CONTENT_SKILLS,
  HOME_PAGE_FEATURE_MB_PUBLISH_UNIT,
  HOME_PAGE_FEATURE_SNP,
  HOME_PAGE_FEATURE_LEARNER_PORTFOLIO,
  HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
  HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS,
  HOME_PAGE_FEATURE_CURRICULUM_MAPS,
  HOME_PAGE_FEATURE_STUDENT_PLANS,
  HOME_PAGE_PORTFOLIO_REVIEW,
  HOME_PAGE_THIRD_PARTY_REDIRECT_URL,
  HOME_PAGE_FEATURE_OAUTH_LOGIN,
  HOME_PAGE_FEATURE_MCGRAW_HILL_LTI,
  ESF_SENTRAL_ATTENDANCE,
  ESF_SENTRAL_WELLBEING,
  ESF_SENTRAL_TIMETABLE,
  ESF_SENTRAL_POLICIES,
  HOME_PAGE_FEATURE_PLANNING_INSIGHTS,
  HOME_PAGE_FEATURE_GRADEBOOK,
  ESF_SENTRAL_PXP,
  ESF_SENTRAL_NEWSFEED,
  ESF_SENTRAL_DAILY_NOTICE,
  HOME_PAGE_FEATURE_SAML_PROVIDERS,
  MODULES_AND_PROJECTS_FEATURES,
  HOME_PAGE_POWER_BI_CARD,
} from "./Constants";
import {
  getModuleEnabledInAnyCurriculum,
  getPermissionEnabledInAnyCurriculum,
  getFilteredUserCurriculumProgramIds,
  getIsCombineCurriculumHomePageEnabled,
} from "Platform/modules/PlatformUtils";
import { SENTRAL_PERMISSION_CONFIGURATIONS } from "Login/components/SentralPortalModal/SentralPortalUtils";
import { isPypVersion1 } from "ProgressReportCommon/utils";
import { getCanAccessBehaviourDashboardInRnPOrg } from "Utils/BehaviourUtils";

export const getModuleSubLabel = ({
  t,
  feature,
  endDate,
  subjects,
  startDate,
  unreadMessageCount,
  unreadCircularCount,
  messagingV2UnreadChatCount,
  isFutureAcademicYearSelected,
  isCurrentAcademicYearSelected,
  isCurrentSelectedLanguagePortuguese,
}) => {
  switch (feature) {
    case HOME_PAGE_FEATURE_CALENDAR: {
      return isCurrentAcademicYearSelected
        ? isCurrentSelectedLanguagePortuguese
          ? moment().format("D [de] MMMM ...")
          : moment().format("Do MMM, YYYY")
        : isFutureAcademicYearSelected
        ? isCurrentSelectedLanguagePortuguese
          ? moment(startDate).format("D [de] MMMM [de] YYYY")
          : moment(startDate).format("Do MMM, YYYY")
        : isCurrentSelectedLanguagePortuguese
        ? moment(endDate).format("D [de] MMMM [de] YYYY")
        : moment(endDate).format("Do MMM, YYYY");
    }

    case HOME_PAGE_FEATURE_FAMILY_COMMUNICATION: {
      return getSubLabel({
        type: "familyMessaging",
        props: { t, unreadMessageCount },
      });
    }

    case HOME_PAGE_FEATURE_MB_CONTENT_SKILLS: {
      return `${subjects.length} subjects`;
    }

    case ESF_SENTRAL_WELLBEING:
    case ESF_SENTRAL_ATTENDANCE:
    case ESF_SENTRAL_TIMETABLE:
    case ESF_SENTRAL_POLICIES:
    case ESF_SENTRAL_PXP:
    case ESF_SENTRAL_NEWSFEED:
    case ESF_SENTRAL_DAILY_NOTICE: {
      return t("common:powered_by_sentral");
    }

    default: {
      return null;
    }
  }
};

export const getModuleLabel = ({
  feature,
  t,
  userType,
  organizationId,
  behaviourNomenclatureConstants,
}) => {
  switch (feature) {
    case HOME_PAGE_FEATURE_ANNOUNCEMENT: {
      return t("announcement:school_announcements");
    }
    case HOME_PAGE_FEATURE_MCGRAW_HILL_LTI: {
      return getLTIName("mcgrawhill");
    }
    case HOME_PAGE_FEATURE_ATTENDANCE: {
      return t("attendance:attendance_manager");
    }
    case HOME_PAGE_FEATURE_TIMETABLE: {
      return t("common:timetable");
    }
    case HOME_PAGE_FEATURE_CLASSROOM_TODO: {
      return getClassRoomTodoText({
        t,
        userType,
      });
    }
    case HOME_PAGE_FEATURE_CALENDAR: {
      return t("calendar:calendar");
    }

    case HOME_PAGE_FEATURE_COURSES: {
      return t("course:courses");
    }

    case HOME_PAGE_FEATURE_FAMILY_COMMUNICATION: {
      return t("configuration:family_messaging");
    }

    case HOME_PAGE_FEATURE_MESSAGING: {
      return t("teacherHomePage:messaging");
    }

    case HOME_PAGE_FEATURE_PROGRESS_REPORT: {
      return ACLStore.can("FeatureFlag:IsMapleBearOrg")
        ? t("teacherHomePage:progress_report_and_portfolios")
        : t("teacherHomePage:progress_report");
    }

    case HOME_PAGE_FEATURE_SNP: {
      const snpModuleLabelSetting = getSettingValue({
        organizationId,
        name: "AppSettingSnpModuleLabel",
      });

      return t(`snp:${snpModuleLabelSetting}`, {
        defaultValue: snpModuleLabelSetting,
      });
    }

    case HOME_PAGE_FEATURE_LEARNER_PORTFOLIO: {
      return t("journal:learner_portfolio");
    }

    case HOME_PAGE_FEATURE_EDUCATOR_CENTER: {
      return t("common:school_policies_and_resources");
    }

    case HOME_PAGE_FEATURE_GOALS: {
      return t("studentGoals:student_goals");
    }

    case HOME_PAGE_FEATURE_MB_LIBRARY: {
      return `MB ${t("common:library")}`;
    }

    case HOME_PAGE_FEATURE_HOMEROOM: {
      return t("attendance:homeroom");
    }

    case HOME_PAGE_FEATURE_DP_SUBJECT_CENTER: {
      return t("common:subject_center");
    }

    case HOME_PAGE_FEATURE_TODDLE_ANALYTICS: {
      return t("common:insights");
    }

    case HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT: {
      return (
        behaviourNomenclatureConstants?.MODULE ||
        t("behaviour:behaviour_management")
      );
    }

    case HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER: {
      return t("configuration:educator_center");
    }

    case HOME_PAGE_FEATURE_MB_CONTENT_SKILLS: {
      return t("common:benchmarks_label");
    }

    case HOME_PAGE_FEATURE_MB_PUBLISH_UNIT: {
      return t("common:manage_with_label", {
        label: t("unitPlan:unit_publishing"),
      });
    }

    case HOME_PAGE_FEATURE_SCHOOL_LIBRARY: {
      return t("common:school_library");
    }

    case HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS: {
      return t("common:planning_insights");
    }

    case HOME_PAGE_FEATURE_CURRICULUM_MAPS: {
      return t("common:curriculum_publishing");
    }

    case HOME_PAGE_FEATURE_STUDENT_PLANS: {
      return t("studentPlans:student_plans");
    }

    case HOME_PAGE_PORTFOLIO_REVIEW: {
      return t("journal:portfolio_post_review");
    }

    case HOME_PAGE_FEATURE_OAUTH_LOGIN: {
      const oauthService = getOauthServiceName({ organizationId });
      return t("teacherHomePage:sso_service", {
        service: _.toLower(oauthService),
      });
    }
    case HOME_PAGE_FEATURE_TIMETABLE_MANAGER: {
      return "Timetable Manager";
    }

    case ESF_SENTRAL_WELLBEING: {
      return t("common:wellbeing");
    }
    case ESF_SENTRAL_ATTENDANCE: {
      return t("common:attendance");
    }
    case ESF_SENTRAL_TIMETABLE: {
      return t("common:timetable");
    }
    case ESF_SENTRAL_POLICIES: {
      return t("common:policies_and_resources");
    }
    case ESF_SENTRAL_PXP: {
      return t("common:pxp");
    }
    case ESF_SENTRAL_NEWSFEED: {
      return t("common:newsfeed");
    }
    case ESF_SENTRAL_DAILY_NOTICE: {
      return t("common:daily_notices");
    }

    case HOME_PAGE_FEATURE_PLANNING_INSIGHTS: {
      return t("teacherHomePage:planning_insights");
    }
    case HOME_PAGE_FEATURE_GRADEBOOK: {
      return t("common:gradebook");
    }

    default: {
      return "No title provided";
    }
  }
};

export const getFeatureIcon = ({ feature, height = 104, width = 104 }) => {
  switch (feature) {
    case HOME_PAGE_FEATURE_ANNOUNCEMENT:
      return <Announcements3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_ATTENDANCE:
      return <AttendanceManager3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_TIMETABLE:
      return <Timetable3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_TIMETABLE_MANAGER:
      return <Timetable3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_CALENDAR:
      return <Calendar3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_COURSES:
      return <BookStackVertical3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_CLASSROOM_TODO:
      return <ClassroomReview3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_FAMILY_COMMUNICATION:
      return <FamilyCommunication3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_MESSAGING:
      return <FamilyCommunication3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_PROGRESS_REPORT:
      return <ProgressReport3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER:
      return <IbPolicy3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_SNP:
      return <IbAandE3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_MB_CONTENT_SKILLS:
      return <ClipboardList3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_HOMEROOM:
      return <School3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_DP_SUBJECT_CENTER:
      return <Workbook3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_LEARNER_PORTFOLIO:
      return <Journal3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_MB_LIBRARY:
      return <Journal3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_GOALS:
      return <Goals3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_TODDLE_ANALYTICS:
      return <Analytics3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT:
      return <HeadHeart3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_EDUCATOR_CENTER:
      return <IbPolicy3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_MB_PUBLISH_UNIT:
      return <ClassroomReview3D height={height} width={width} />;
    case HOME_PAGE_PORTFOLIO_REVIEW:
      return <Journal3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_SCHOOL_LIBRARY:
      return <BookStackVertical3D height={height} width={width} />;

    case HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS:
      return <PlanningInsights3D height={height} width={width} />;

    case HOME_PAGE_FEATURE_CURRICULUM_MAPS:
      return <CardUnit3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_STUDENT_PLANS:
      return <Document3D height={height} width={width} />;
    case HOME_PAGE_THIRD_PARTY_REDIRECT_URL:
      return <Link3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_OAUTH_LOGIN:
      return <StaffPermissions3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_SAML_PROVIDERS:
      return <StaffPermissions3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_MCGRAW_HILL_LTI:
      return <Sync3D height={height} width={width} />;
    case ESF_SENTRAL_WELLBEING:
      return <HeadHeart3D height={height} width={width} />;
    case ESF_SENTRAL_ATTENDANCE:
      return <AttendanceManager3D height={height} width={width} />;
    case ESF_SENTRAL_TIMETABLE:
      return <Timetable3D height={height} width={width} />;
    case ESF_SENTRAL_POLICIES:
      return <IbPolicy3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_PLANNING_INSIGHTS:
      return <PlanningInsights3D height={height} width={width} />;
    case HOME_PAGE_FEATURE_GRADEBOOK:
      return <BookSpiralGrade3D height={height} width={width} />;
    case ESF_SENTRAL_PXP:
      return <AttendanceManager3D height={height} width={width} />;
    case ESF_SENTRAL_NEWSFEED:
      return <StudentGuidance3D height={height} width={width} />;
    case ESF_SENTRAL_DAILY_NOTICE:
      return <Notes3D height={height} width={width} />;
    case HOME_PAGE_POWER_BI_CARD:
      return <Link3D height={height} width={width} />;
  }
};

export const FEATURE_STYLE_MAP = {
  [HOME_PAGE_FEATURE_ANNOUNCEMENT]: styles.pink900BackgroundStyle,
  [HOME_PAGE_FEATURE_ATTENDANCE]: styles.yellow900BackgroundStyle,
  [HOME_PAGE_FEATURE_CALENDAR]: styles.yellow900BackgroundStyle,
  [HOME_PAGE_FEATURE_COURSES]: styles.orange900BackgroundStyle,
  [HOME_PAGE_FEATURE_CLASSROOM_TODO]: styles.pink900BackgroundStyle,
  [HOME_PAGE_FEATURE_FAMILY_COMMUNICATION]: styles.green900BackgroundStyle,
  [HOME_PAGE_FEATURE_MESSAGING]: styles.green900BackgroundStyle,
  [HOME_PAGE_FEATURE_PROGRESS_REPORT]: styles.green900BackgroundStyle,
  [HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER]: styles.teal900BackgroundStyle,
  [HOME_PAGE_FEATURE_SNP]: styles.orange900BackgroundStyle,
  [HOME_PAGE_FEATURE_MB_CONTENT_SKILLS]: styles.pink900BackgroundStyle,
  [HOME_PAGE_FEATURE_HOMEROOM]: styles.yellow900BackgroundStyle,
  [HOME_PAGE_FEATURE_DP_SUBJECT_CENTER]: styles.orange900BackgroundStyle,
  [HOME_PAGE_FEATURE_LEARNER_PORTFOLIO]: styles.blue900BackgroundStyle,
  [HOME_PAGE_FEATURE_MB_LIBRARY]: styles.blue900BackgroundStyle,
  [HOME_PAGE_FEATURE_GOALS]: styles.blue900BackgroundStyle,
  [HOME_PAGE_FEATURE_TODDLE_ANALYTICS]: styles.purple900BackgroundStyle,
  [HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT]: styles.violet900BackgroundStyle,
  [HOME_PAGE_FEATURE_EDUCATOR_CENTER]: styles.teal900BackgroundStyle,
  [HOME_PAGE_FEATURE_MB_PUBLISH_UNIT]: styles.pink900BackgroundStyle,
  [HOME_PAGE_PORTFOLIO_REVIEW]: styles.blue900BackgroundStyle,
  [HOME_PAGE_FEATURE_SCHOOL_LIBRARY]: styles.orange900BackgroundStyle,
  [HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS]: styles.teal900BackgroundStyle,
  [HOME_PAGE_FEATURE_CURRICULUM_MAPS]: styles.green900BackgroundStyle,
  [HOME_PAGE_FEATURE_STUDENT_PLANS]: styles.violet900BackgroundStyle,
  [HOME_PAGE_THIRD_PARTY_REDIRECT_URL]: styles.blue900BackgroundStyle,
  [HOME_PAGE_FEATURE_TIMETABLE]: styles.orange900BackgroundStyle,
  [HOME_PAGE_FEATURE_TIMETABLE_MANAGER]: styles.orange900BackgroundStyle,
  [HOME_PAGE_FEATURE_OAUTH_LOGIN]: styles.green900BackgroundStyle,
  [HOME_PAGE_FEATURE_SAML_PROVIDERS]: styles.green900BackgroundStyle,
  [HOME_PAGE_FEATURE_MCGRAW_HILL_LTI]: styles.teal900BackgroundStyle,
  [ESF_SENTRAL_WELLBEING]: styles.blue900BackgroundStyle,
  [ESF_SENTRAL_ATTENDANCE]: styles.blue900BackgroundStyle,
  [ESF_SENTRAL_TIMETABLE]: styles.blue900BackgroundStyle,
  [ESF_SENTRAL_POLICIES]: styles.blue900BackgroundStyle,
  [HOME_PAGE_FEATURE_PLANNING_INSIGHTS]: styles.teal900BackgroundStyle,
  [HOME_PAGE_FEATURE_GRADEBOOK]: styles.blue900BackgroundStyle,
  [ESF_SENTRAL_PXP]: styles.blue900BackgroundStyle,
  [ESF_SENTRAL_NEWSFEED]: styles.blue900BackgroundStyle,
  [ESF_SENTRAL_DAILY_NOTICE]: styles.blue900BackgroundStyle,
  [HOME_PAGE_POWER_BI_CARD]: styles.blue900BackgroundStyle,
};

const getShowProgressReportButtonCard = ({ currentCurriculumProgramType }) => {
  const isModuleEnabled = ACLStorage.getModuleSettingsValue(
    PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION
  );

  switch (currentCurriculumProgramType) {
    case CURRICULUM_TYPE_DP:
    case CURRICULUM_TYPE_MYP:
    case CURRICULUM_TYPE_UBD: {
      return isModuleEnabled;
    }
    // We will show progress report button for PYP in 2.0.
    case CURRICULUM_TYPE_PYP: {
      return (
        !isPypVersion1({ curriculumType: CURRICULUM_TYPE_PYP }) &&
        isModuleEnabled
      );
    }
    default:
      return false;
  }
};

const checkHomePageFeaturesVisibilityWrtRnP = controlParameterName => {
  if (ACLStore.can(COMBINE_CURRICULUM_HOME_PAGE_PERMISSION)) {
    const userCurriculumPrograms = getUserCurriculumPrograms();
    return _.some(userCurriculumPrograms, curriculumProgram => {
      const contextParameters = [
        {
          entityType: "CURRICULUM_PROGRAM",
          entityId: curriculumProgram.id,
        },
      ];

      return ACLStorage.getModuleSettingsValueByContext(
        controlParameterName,
        contextParameters
      );
    });
  }

  return ACLStorage.getModuleSettingsValue(controlParameterName);
};

const HOME_PAGE_FEATURES_FOR_NON_CENTRAL_REPO_ORGANIZATIONS = [
  {
    key: HOME_PAGE_FEATURE_ANNOUNCEMENT,
    dataTestId: "button-dashboard-feature-announcement",
    getVisibilityStatus: ({ isFutureAcademicYearSelected }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_ANNOUNCEMENT
        );

      return !isFutureAcademicYearSelected &&
        ACLStorage.getModuleSettingsValue(CAN_VIEW_ANNOUNCEMENT_MODULE)
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  // TODO: here
  {
    key: HOME_PAGE_FEATURE_ATTENDANCE,
    dataTestId: "button-dashboard-feature-attendance-manager",
    getVisibilityStatus: ({ isFutureAcademicYearSelected, isAdmin }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_ATTENDANCE);

      const isSentralAttendanceEnabled = isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE
      );
      const isModuleEnabled = getIsRnpConsumptionAllowed()
        ? checkHomePageFeaturesVisibilityWrtRnP(
            ATTENDANCE_DASHBOARD_ACCESS_PERMISSION
          )
        : ACLStore.can("TeacherPortal:Attendance") &&
          (ACLStore.can("TeacherPortal:AttendanceDashboard") ||
            hasModuleAdminAccess({
              moduleName: MODULES.ATTENDANCE.id,
            }));

      return !isFutureAcademicYearSelected &&
        isModuleEnabled &&
        !isSentralAttendanceEnabled
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_CLASSROOM_TODO,
    dataTestId: "button-dashboard-classroom-review",
    getVisibilityStatus: ({
      userType,
      isFutureAcademicYearSelected,
      canViewADMWidget,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_CLASSROOM_TODO
        );

      const showClassroomTodo = ACLStore.can("Common:AssignmentsManager");

      return !isFutureAcademicYearSelected &&
        showClassroomTodo &&
        !canViewADMWidget
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_CALENDAR,
    dataTestId: "button-dashboard-feature-my-calendar",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_CALENDAR);

      const showCalendar = checkHomePageFeaturesVisibilityWrtRnP(
        CAN_VIEW_CALENDAR_MODULE_SETTING
      );
      return showCalendar ? "VISIBLE" : "NOT_VISIBLE";
    },
  },
  // This will be added when blueprint courses are available
  // {
  //   key: HOME_PAGE_FEATURE_COURSES,
  //   dataTestId: "button-dashboard-feature-courses",
  //   getVisibilityStatus: () => {
  //     return getIsLearningCoursesEnabled() ? "VISIBLE" : "NOT_VISIBLE";
  //   },
  // },
  {
    key: HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
    dataTestId: "button-dashboard-feature-family-messaging",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      isCurrentAcademicYearSelected,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_FAMILY_COMMUNICATION
        );

      return !isFutureAcademicYearSelected &&
        isCurrentAcademicYearSelected &&
        rolesAndPermissionsShowMessagingCard()
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MESSAGING,
    dataTestId: "button-dashboard-feature-messagingV2",
    getVisibilityStatus: ({ isCurrentAcademicYearSelected }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_MESSAGING);

      return isMessagingV2Enabled() && isCurrentAcademicYearSelected
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_PROGRESS_REPORT,
    dataTestId: "button-dashboard-feature-progress-report",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      currentCurriculumProgramType,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_PROGRESS_REPORT
        );

      return !isFutureAcademicYearSelected &&
        getShowProgressReportButtonCard({ currentCurriculumProgramType })
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_SNP,
    dataTestId: "button-dashboard-feature-authorization-evaluation",
    getVisibilityStatus: ({ organizationId, curriculumProgramIds }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_SNP);

      const isModuleEnabled = getModuleEnabledInAnyCurriculum({
        module: SNPv2_ACCESS_PERMISSION,
        curriculumProgramIds,
      });

      const canManageEvaluationCycles = getPermissionEnabledInAnyCurriculum({
        permission: SNPv2_MANAGE_EVALUATION_CYCLES_PERMISSION,
        curriculumProgramIds,
      });

      const snpEnabledCurriculumProgramIds = getFilteredUserCurriculumProgramIds(
        {
          permission: SNPv2_ACCESS_PERMISSION,
          curriculumProgramIds,
        }
      );

      const totalNewSnpCycles = getNewSnPCyclesCount({
        organizationId,
        curriculumProgramId: snpEnabledCurriculumProgramIds,
      });

      return isModuleEnabled &&
        (totalNewSnpCycles > 0 || canManageEvaluationCycles)
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_LEARNER_PORTFOLIO,
    dataTestId: "button-dashboard-feature-learner-portfolio",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      currentCurriculumProgramType,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_LEARNER_PORTFOLIO
        );

      return !isFutureAcademicYearSelected &&
        currentCurriculumProgramType == CURRICULUM_TYPE_DP &&
        ACLStore.can("Common:LearnerPortfolio")
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_EDUCATOR_CENTER,
    dataTestId: "button-dashboard-feature-educator-center",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_EDUCATOR_CENTER
        );

      const isSentralPoliciesEnabled = isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES
      );
      let canShowEducatorCenterCard;
      if (ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
        canShowEducatorCenterCard = checkHomePageFeaturesVisibilityWrtRnP(
          VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION
        );
      } else {
        canShowEducatorCenterCard = ACLStore.can(EDUCATOR_CENTER_REVAMP);
      }
      return canShowEducatorCenterCard && !isSentralPoliciesEnabled
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_GOALS,
    dataTestId: "button-dashboard-feature-goals",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      curriculumProgramIds,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_GOALS);

      const canShowGoalsCard = canViewStudentGoals(curriculumProgramIds);

      return !isFutureAcademicYearSelected && canShowGoalsCard
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MB_LIBRARY,
    dataTestId: "button-dashboard-feature-mb-library",
    getVisibilityStatus: ({ organizationTags }) => {
      return isMapleBearLikeEducator({
        organizationTags,
      })
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_HOMEROOM,
    dataTestId: "button-dashboard-feature-attendance-homeroom",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      userId,
      academicYearSelected,
      currentCurriculumProgramId,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_HOMEROOM);

      const homeroomStudentCount = getHomeroomStudentsCount({
        userId,
        academicYearSelected,
        currentCurriculumProgramId,
      });

      const isHomeroomVisible = getIsRnpConsumptionAllowed()
        ? ACLStorage.getModuleSettingsValue(HOMEROOM_ACCESS_PERMISSION)
        : ACLStore.can("TeacherPortal:Attendance") &&
          ACLStore.can("Common:Homeroom");

      const isHomeroomCardVisible =
        isHomeroomVisible && homeroomStudentCount > 0;

      return !isFutureAcademicYearSelected && isHomeroomCardVisible
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_DP_SUBJECT_CENTER,
    dataTestId: "button-dashboard-feature-subject-center",
    getVisibilityStatus: ({
      currentCurriculumProgramType,
      isFutureAcademicYearSelected,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_DP_SUBJECT_CENTER
        );

      const showDPSubjectCenterCard =
        _.isEqual(CURRICULUM_TYPE_DP, currentCurriculumProgramType) &&
        ACLStore.can("FeatureFlag:SubjectCenter");

      return !isFutureAcademicYearSelected && showDPSubjectCenterCard
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_TODDLE_ANALYTICS,
    dataTestId: "button-dashboard-feature-toddle-insights",
    getVisibilityStatus: ({ isCurrentAcademicYearSelected }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_TODDLE_ANALYTICS
        );

      return isCurrentAcademicYearSelected && isToddleAnalyticsEnabled()
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
    dataTestId: "button-dashboard-feature-behaviour-management",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      currentCurriculumProgramId,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT
        );

      let hasModuleAccess = false;

      if (
        ACLStore.can(
          [
            ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
            ENABLE_RNP_CONSUMPTION_IN_BEHAVIOUR,
          ],
          "all"
        )
      ) {
        hasModuleAccess = getCanAccessBehaviourDashboardInRnPOrg({
          curriculumProgramId: currentCurriculumProgramId,
        });
      } else {
        const { hasStaffAccessPermission } = getAccessLevels({
          [MODULES.BEHAVIOUR_MANAGEMENT.id]: {
            hasStaffAccessPermission: {
              rule: RULE_OPTIONS.gte,
              value: MODULES.BEHAVIOUR_MANAGEMENT.values.TEACHER_ACCESS.id,
              defaultAccess: true,
            },
          },
        });

        hasModuleAccess =
          ACLStore.can(ENABLE_BEHAVIOUR_MODULE_PERM) &&
          hasStaffAccessPermission;
      }

      const isSentralPortalWellbeingFeatureEnabled = isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING
      );

      return !isFutureAcademicYearSelected &&
        hasModuleAccess &&
        !isSentralPortalWellbeingFeatureEnabled
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
    dataTestId: "button-dashboard-feature-school-library",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_SCHOOL_LIBRARY
        );

      return isSchoolLibraryEnabled() ? "VISIBLE" : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS,
    dataTestId: "button-dashboard-feature-curriculum-insights",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS
        );

      if (!isCurriculumInsightsEnabled()) {
        return "NOT_VISIBLE";
      }

      return ACLStorage.getModuleSettingsValue(
        PLANNING_INSIGHTS_PROGRAMME_LEVEL_VIEW_PERMISSION
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_CURRICULUM_MAPS,
    dataTestId: "button-dashboard-feature-curriculum-maps",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_CURRICULUM_MAPS
        );

      return getIsCurriculumMapsEnabled() ? "VISIBLE" : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_STUDENT_PLANS,
    dataTestId: "button-dashboard-feature-student-plans",
    getVisibilityStatus: () =>
      ACLStore.can("Common:StudentPlans") ? "VISIBLE" : "NOT_VISIBLE",
  },
  {
    key: HOME_PAGE_PORTFOLIO_REVIEW,
    dataTestId: "button-dashboard-feature-portfolio-review",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      organizationId,
      userId,
      currentCurriculumProgramId,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_PORTFOLIO_REVIEW);

      const staffPermission = getSettingValue({
        name: "StaffPermission:PortfolioReviewer",
        organizationId,
        userId,
        currentCurriculumProgramId,
      });
      return !isFutureAcademicYearSelected &&
        ACLStore.can("EnablePortfolioReviewer") &&
        _.includes(staffPermission, "REVIEW")
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_TIMETABLE,
    dataTestId: "button-dashboard-feature-timetable",
    getVisibilityStatus: ({
      isFutureAcademicYearSelected,
      canViewTimetableWidget,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_TIMETABLE);

      const isSentralTimetableEnabled = isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE
      );
      return !isFutureAcademicYearSelected &&
        isTimetableWidgetEnabled() &&
        !canViewTimetableWidget &&
        !isSentralTimetableEnabled
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_OAUTH_LOGIN,
    dataTestId: "button-dashboard-feature-oauth-login",
    getVisibilityStatus: ({ organizationId }) => {
      const oauthServiceName = getOauthServiceName({ organizationId });
      return ACLStore.can("FeatureFlag:EnableOauthSSO") &&
        !_.isEmpty(oauthServiceName)
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MCGRAW_HILL_LTI,
    dataTestId: "button-dashboard-feature-mcgrawhill-lti",
    getVisibilityStatus: ({ ltiDropDownOptions }) => {
      if (getIsCombineCurriculumHomePageEnabled()) {
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_MCGRAW_HILL_LTI
        );
      }

      const isMcGrawHillServicePresent = isLtiServiceAvailable(
        ltiDropDownOptions,
        "MCGRAWHILL"
      );

      return getIsMcGrawHillLTIToolEnabled() && isMcGrawHillServicePresent
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_TIMETABLE_MANAGER,
    dataTestId: "button-dashboard-feature-timetable-manager",
    getVisibilityStatus: ({
      isToddleV2TimetableEnabled,
      isFutureAcademicYearSelected,
      curriculumProgramIds,
    }) => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_TIMETABLE_MANAGER
        );

      const curriculumProgramId = _.first(curriculumProgramIds);

      const isUserHasTimetableManagerAccess = ACLStorage.getModuleSettingsValueByContext(
        TIMETABLE_MANAGER_ACCESS_PERMISSION,
        [
          {
            entityType: "CURRICULUM_PROGRAM",
            entityId: curriculumProgramId,
          },
        ]
      );

      return !isFutureAcademicYearSelected &&
        isToddleV2TimetableEnabled &&
        isUserHasTimetableManagerAccess
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_WELLBEING,
    dataTestId: "button-dashboard-feature-esf-sentral-wellbeing",
    isSentralNotificationActive: true,
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_ATTENDANCE,
    dataTestId: "button-dashboard-feature-esf-sentral-attendance",
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_TIMETABLE,
    dataTestId: "button-dashboard-feature-esf-sentral-timetable",
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_POLICIES,
    dataTestId: "button-dashboard-feature-esf-sentral-policies",
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_PLANNING_INSIGHTS,
    dataTestId: "button-dashboard-feature-planning-insights",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_PLANNING_INSIGHTS
        );

      // planning insights is not ready for 2.0 orgs
      const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

      if (isLearningCoursesEnabled) {
        return "NOT_VISIBLE";
      }

      // planning insights is superseded by curriculum insights
      if (isCurriculumInsightsEnabled()) {
        return "NOT_VISIBLE";
      }

      return ACLStorage.getModuleSettingsValue(
        PLANNING_INSIGHTS_PROGRAMME_LEVEL_VIEW_PERMISSION
      ) && getIsNewAdminUIEnabled()
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_GRADEBOOK,
    dataTestId: "button-dashboard-feature-gradebook",
    getVisibilityStatus: () => {
      if (getIsCombineCurriculumHomePageEnabled())
        return getHomepageFeatureVisibilityStatus(HOME_PAGE_FEATURE_GRADEBOOK);

      return ACLStorage.getModuleSettingsValue(
        ADMIN_GRADEBOOK_ACCESS_PERMISSION
      ) && getIsNewAdminUIEnabled()
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_PXP,
    dataTestId: "button-dashboard-feature-esf-sentral-pxp",
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.PXP
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_NEWSFEED,
    dataTestId: "button-dashboard-feature-esf-sentral-news-feed",
    isSentralNotificationActive: true,
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.NEWSFEED
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: ESF_SENTRAL_DAILY_NOTICE,
    dataTestId: "button-dashboard-feature-esf-sentral-notice",
    isSentralNotificationActive: true,
    getVisibilityStatus: () => {
      return isSentralPortalFeatureEnabled(
        SENTRAL_PERMISSION_CONFIGURATIONS.NOTICE
      )
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
];

/* Future Academic Year condition will be revisited by 3A while AYT-V2 Sprint */
const HOME_PAGE_FEATURES_FOR_CENTRAL_REPO_ORGANIZATIONS = [
  {
    key: HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER,
    dataTestId: "button-dashboard-feature-mb-educator-center",
    getVisibilityStatus: () => {
      return ACLStore.can("TeacherPortal:EducationCenter")
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MB_CONTENT_SKILLS,
    dataTestId: "button-dashboard-feature-mb-content-skills",
    getVisibilityStatus: () => {
      return ACLStore.can("TeacherPortal:ContentSkills")
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MESSAGING,
    dataTestId: "button-dashboard-feature-messagingV2",
    getVisibilityStatus: () => {
      return isMessagingV2Enabled() ? "VISIBLE" : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MB_PUBLISH_UNIT,
    dataTestId: "button-dashboard-feature-mb-publish-unit",
    getVisibilityStatus: () => {
      return ACLStore.can("TeacherPortal:ManageUnitPublish")
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_PORTFOLIO_REVIEW,
    dataTestId: "button-dashboard-feature-portfolio-review",
    getVisibilityStatus: ({
      organizationId,
      userId,
      currentCurriculumProgramId,
    }) => {
      const staffPermission = getSettingValue({
        name: "StaffPermission:PortfolioReviewer",
        organizationId,
        userId,
        currentCurriculumProgramId,
      });
      return ACLStore.can("EnablePortfolioReviewer") &&
        _.includes(staffPermission, "REVIEW")
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
  {
    key: HOME_PAGE_FEATURE_MCGRAW_HILL_LTI,
    dataTestId: "button-dashboard-feature-mcgrawhill-lti",
    getVisibilityStatus: ({ ltiDropDownOptions }) => {
      if (getIsCombineCurriculumHomePageEnabled()) {
        return getHomepageFeatureVisibilityStatus(
          HOME_PAGE_FEATURE_MCGRAW_HILL_LTI
        );
      }

      const isMcGrawHillServicePresent = isLtiServiceAvailable(
        ltiDropDownOptions,
        "MCGRAWHILL"
      );

      return getIsMcGrawHillLTIToolEnabled() && isMcGrawHillServicePresent
        ? "VISIBLE"
        : "NOT_VISIBLE";
    },
  },
];

export const getHomePageFeatures = ({
  isCurriculumProgramFree,
  organizationTags,
  isFutureAcademicYearSelected,
  isAdmin,
  currentCurriculumProgramType,
  userType,
  isCurrentAcademicYearSelected,
  organizationId,
  currentCurriculumProgramId,
  academicYearSelected,
  userId,
  userCurriculumPrograms,
  canViewADMWidget,
  canViewTimetableWidget,
  ltiDropDownOptions,
  curriculumProgramIds,
  isToddleV2TimetableEnabled,
}) => {
  /**
   * For free programs, no homepage features should be visible
   */
  if (isCurriculumProgramFree) return [];

  /**
   * An organisation can be a Maple Bear central repo or a regular organisation.
   * For regular case, below features should be considered.
   */
  if (!mapleBearLikeCentralOrg({ organizationTags })) {
    return _.filter(
      HOME_PAGE_FEATURES_FOR_NON_CENTRAL_REPO_ORGANIZATIONS,
      feature => {
        return (
          feature?.getVisibilityStatus?.({
            isFutureAcademicYearSelected,
            isAdmin,
            currentCurriculumProgramType,
            userType,
            isCurrentAcademicYearSelected,
            organizationId,
            currentCurriculumProgramId,
            academicYearSelected,
            userId,
            userCurriculumPrograms,
            organizationTags,
            canViewADMWidget,
            canViewTimetableWidget,
            ltiDropDownOptions,
            curriculumProgramIds,
            isToddleV2TimetableEnabled,
          }) === "VISIBLE"
        );
      }
    );
  }

  /**
   * For central repo organisations, below features should be considered.
   */
  if (isFutureAcademicYearSelected) return [];

  return _.filter(
    HOME_PAGE_FEATURES_FOR_CENTRAL_REPO_ORGANIZATIONS,
    feature => {
      return (
        feature?.getVisibilityStatus?.({
          organizationId,
          userId,
          currentCurriculumProgramId,
          canViewADMWidget,
          canViewTimetableWidget,
          ltiDropDownOptions,
        }) === "VISIBLE"
      );
    }
  );
};

export const getFeatureCountValue = ({
  feature,
  unreadCircularCount,
  newConversationsCount,
  MBlibraryUnitUnseenCount,
  messagingV2UnreadChatCount,
}) => {
  switch (feature) {
    case HOME_PAGE_FEATURE_ANNOUNCEMENT:
      return unreadCircularCount;
    case HOME_PAGE_FEATURE_FAMILY_COMMUNICATION:
      return newConversationsCount;
    case HOME_PAGE_FEATURE_MB_LIBRARY:
      return MBlibraryUnitUnseenCount;
    case HOME_PAGE_FEATURE_MESSAGING:
      return messagingV2UnreadChatCount;
    default:
      return null;
  }
};

export const isAssignmentAndDeadlineManagerEnable = () => {
  const { assignmentsManager } = HOMEPAGE_WIDGETS_BE_KEYS;

  return getIsCombineCurriculumHomePageEnabled()
    ? checkIsHomepageWidgetEnabled(assignmentsManager)
    : ACLStore.can("FeatureFlag:EnableAssignmentAndDeadlineManager") &&
        ACLStore.can("Common:AssignmentsManager");
};

export const isQuickLinksWidgetEnabled = () => {
  const { quickLinkWidget } = HOMEPAGE_WIDGETS_BE_KEYS;

  return getIsCombineCurriculumHomePageEnabled()
    ? checkIsHomepageWidgetEnabled(quickLinkWidget)
    : ACLStore.can(STATIC_WIDGETISED_SCHOOL_HOMEPAGE);
};

export const getDataGroupedByCurriculum = ({
  data = [],
  valueField = "id",
  labelField = "name",
  generateSortedData = false,
}) => {
  const groupedByCurriculum = _.groupBy(data, item =>
    _.get(item, "curriculumProgram.id")
  );

  if (_.size(groupedByCurriculum) <= 1) {
    return _.map(data, item => {
      return {
        label: item[labelField],
        value: item[valueField],
      };
    });
  }

  const formattedData = _.reduce(
    groupedByCurriculum,
    (result, groupedValues) => {
      const firstItem = _.first(groupedValues);
      const acronym = _.get(firstItem, "curriculumProgram.acronym");
      const curriculumProgramType = _.get(firstItem, "curriculumProgram.type");

      const options = groupedValues.map(item => ({
        value: item[valueField],
        label: item[labelField],
      }));

      result.push({
        label: acronym,
        options,
        curriculumProgramType,
      });

      return result;
    },
    []
  );

  if (!generateSortedData) {
    return formattedData;
  }

  const sortedData = _.orderBy(
    formattedData,
    [obj => CURRICULUM_TYPE_ORDER_MAPPING[obj.curriculumProgramType]],
    "asc"
  );
  return sortedData;
};

export const logFeatureClick = ({ feature }) => {
  switch (feature) {
    case HOME_PAGE_FEATURE_CALENDAR: {
      recordEvent({
        eventName: "2D_CALENDAR",
        eventData: {
          type: "ACCESSED_CALENDAR",
          portal: "WEB",
          calendarType: "MASTER_CALENDAR",
          source: "HOMEPAGE",
          description: "Accessing master calendar card from homepage",
        },
      });
      break;
    }
  }
};

export const getStatusOptionsMemoized = getMemoizedLangFunction(({ t }) => {
  return [
    {
      label: t("common:active_label", {
        label: t("course:course_lowercase_plural"),
      }),
      value: "Active",
    },
    {
      label: t("common:archive_with_label", {
        label: t("course:course_lowercase_plural"),
      }),
      value: "Archived",
    },
  ];
});

const getFilterOptions = ({
  t,
  filters,
  statusOptions,
  gradeOptions,
  subjectGroupOptions,
  organizationGenericTagOptions,
  regionTagOptions,
  subjectOptions,
  availableCurriculumTypes,
  showArchivedOptions,
  canListAndAccessAllClasses,
  userMappedCoursesCount,
  isMapleBearLikeOrg,
}) => {
  const options = {};
  const defaultSelectedOptions = {};

  const populateDefaultSelectedOptions = ({ filterName, filterOptions }) => {
    let filtersValue = _.get(filters, filterName, []);
    if (_.upperCase(filtersValue) == "ALL") {
      defaultSelectedOptions[filterName] = _.map(filterOptions, "value");
    } else {
      if (filterName == "archivalState" && !_.isArray(filtersValue)) {
        filtersValue = [filtersValue];
      }
      defaultSelectedOptions[filterName] = filtersValue;
    }
  };

  const classViewOptions = [
    {
      label: t("common:all_classes_plural"),
      value: "ALL_CLASSES",
      key: "ALL_CLASSES",
    },
    {
      label: t("common:my_classes_lower"),
      value: "MY_CLASSES",
      key: "MY_CLASSES",
    },
  ];

  //Classes
  if (canListAndAccessAllClasses && userMappedCoursesCount > 0) {
    options["classView"] = {
      options: classViewOptions,
      title: t("common:class_plural"),
      uiType: "RADIO",
    };
    populateDefaultSelectedOptions({
      filterName: "classView",
      filterOptions: classViewOptions,
    });
  }

  // Grades
  options["grade"] = {
    options: gradeOptions,
    title: t("common:grade_plural"),
    allText: t("common:all_grades"),
  };
  populateDefaultSelectedOptions({
    filterName: "grade",
    filterOptions: gradeOptions,
  });

  // Subject Groups
  if (
    _.includes(availableCurriculumTypes, CURRICULUM_TYPE_MYP) ||
    _.includes(availableCurriculumTypes, CURRICULUM_TYPE_DP)
  ) {
    options["subjectGroups"] = {
      options: subjectGroupOptions,
      title: t("common:subject_group_plural"),
      allText: t("common:all_with_lowercase_label", {
        label: t("common:subject_group_plural"),
      }),
    };
    populateDefaultSelectedOptions({
      filterName: "subjectGroups",
      filterOptions: subjectGroupOptions,
    });
  }

  // Organization Generic Tags
  if (_.includes(availableCurriculumTypes, CURRICULUM_TYPE_DP)) {
    options["level"] = {
      options: organizationGenericTagOptions,
      title: t("common:levels"),
      allText: t("common:all_with_lowercase_label", {
        label: t("common:levels"),
      }),
    };
    populateDefaultSelectedOptions({
      filterName: "level",
      filterOptions: organizationGenericTagOptions,
    });
  }

  //Subject
  if (_.includes(availableCurriculumTypes, CURRICULUM_TYPE_UBD)) {
    options["subject"] = {
      options: subjectOptions,
      title: t("common:subject_plural"),
      allText: t("common:all_with_lowercase_label", {
        label: t("common:subject_plural"),
      }),
    };
    populateDefaultSelectedOptions({
      filterName: "subject",
      filterOptions: subjectOptions,
    });
  }

  // Region Tags
  if (regionTagOptions.length > 0) {
    options["region"] = {
      options: regionTagOptions,
      title: t("common:region_plural"),
      allText: t("common:all_with_lowercase_label", {
        label: t("common:region_plural"),
      }),
    };
    populateDefaultSelectedOptions({
      filterName: "region",
      filterOptions: regionTagOptions,
    });
  }

  // Status
  if (showArchivedOptions) {
    options["archivalState"] = {
      options: statusOptions,
      title: t("common:status"),
      allText: t("common:all_with_lowercase_label", {
        label: t("course:course_lowercase_plural"),
      }),
    };
    populateDefaultSelectedOptions({
      filterName: "archivalState",
      filterOptions: statusOptions,
    });
  }

  return { options, defaultSelectedOptions };
};

export const getFilterOptionsMemoized = getMemoizedLangFunction(
  getFilterOptions,
  ({
    filters,
    availableCurriculumTypes,
    showArchivedOptions,
    canListAndAccessAllClasses,
    userMappedCoursesCount,
    isMapleBearLikeOrg,
    gradeOptions,
    subjectGroupOptions,
    organizationGenericTagOptions,
    regionTagOptions,
    subjectOptions,
  }) => {
    return JSON.stringify({
      filters,
      availableCurriculumTypes,
      showArchivedOptions,
      canListAndAccessAllClasses,
      userMappedCoursesCount,
      isMapleBearLikeOrg,
      gradeOptions: _.map(gradeOptions, "id"),
      subjectGroupOptions: _.map(subjectGroupOptions, "id"),
      organizationGenericTagOptions: _.map(organizationGenericTagOptions, "id"),
      regionTagOptions: _.map(regionTagOptions, "id"),
      subjectOptions: _.map(subjectOptions, "id"),
    });
  }
);

export const getFormattedFilterOptions = ({ data, labelField = "name" }) => {
  return _.map(data, item => ({
    label: item[labelField],
    value: item.id,
  }));
};

export const getRegionFilterOptions = ({ data, t }) => {
  return _.map(data, item => ({
    label: t(`common:r_${getMbRegionLocalizedKey({ tagValue: item.value })}`),
    value: item.id,
  }));
};

export const getHiddenFeaturesPreference = () => {
  const isCCHEnabled = getIsCombineCurriculumHomePageEnabled();

  return (
    getSettingValue({
      name: SCHOOL_HOMEPAGE_HIDDEN_MODULES_AND_PROJECTS,
      userId: getUserInfo().id,
      ...(isCCHEnabled ? { readFromUserAndOrgLevel: true } : {}),
    }) || {}
  );
};

export const getModulesAndProjectsOrderPreference = () => {
  const isCCHEnabled = getIsCombineCurriculumHomePageEnabled();
  return (
    getSettingValue({
      name: SCHOOL_HOMEPAGE_MODULES_AND_PROJECTS_ORDER,
      userId: getUserInfo().id,
      ...(isCCHEnabled ? { readFromUserAndOrgLevel: true } : {}),
    }) || []
  );
};

/**
 * Sorts a unified list of items based on a saved order preference.
 * Items present in savedOrder are placed first (in saved order),
 * followed by any new items not present in the saved order.
 */
export const getOrderedItems = ({ items, savedOrder }) => {
  if (_.isEmpty(savedOrder)) return items;

  const positionMap = {};
  _.forEach(savedOrder, (entry, index) => {
    positionMap[`${entry.type}::${entry.id}`] = index;
  });

  const [knownItems, newItems] = _.partition(items, item =>
    _.has(positionMap, `${item.type}::${item.id}`)
  );

  const sortedKnown = _.sortBy(
    knownItems,
    item => positionMap[`${item.type}::${item.id}`]
  );

  return _.concat(sortedKnown, newItems);
};

export const getOrderedItemsByUserPreference = ({
  filteredHomepageFeatures = [],
  filteredThirdPartyRedirectUrlData = [],
  filteredSamlSpProviderDetails = [],
  filteredProjectGroupTypes = [],
  filteredPowerBICards = [],
  isThirdPartyRedirectUrlCardEnabled = false,
  isIdpInitFlowUsingSamlEnabled = false,
  isPowerBICardsEnabled = false,
}) => {
  const {
    HOME_PAGE_FEATURE,
    SAML_SP_PROVIDER,
    THIRD_PARTY_REDIRECT_URL,
    PROJECT_GROUP,
    POWER_BI_CARD,
  } = MODULES_AND_PROJECTS_FEATURES;

  const items = [];

  // 1. Homepage features
  _.forEach(
    filteredHomepageFeatures,
    ({ feature, dataTestId = "", isSentralNotificationActive }) => {
      items.push({
        type: HOME_PAGE_FEATURE,
        id: feature,
        feature,
        dataTestId,
        isSentralNotificationActive,
      });
    }
  );

  // 2. Third party redirect URLs
  if (isThirdPartyRedirectUrlCardEnabled) {
    _.forEach(filteredThirdPartyRedirectUrlData, data => {
      const service = _.get(data, "service", "");
      items.push({
        type: THIRD_PARTY_REDIRECT_URL,
        id: service,
        data,
      });
    });
  }

  // 3. SAML Providers
  if (isIdpInitFlowUsingSamlEnabled) {
    _.forEach(filteredSamlSpProviderDetails, data => {
      const id = _.get(data, "id", "");
      items.push({
        type: SAML_SP_PROVIDER,
        id,
        data,
      });
    });
  }

  // 4. Project groups
  _.forEach(filteredProjectGroupTypes, projectGroupType => {
    items.push({
      type: PROJECT_GROUP,
      id: projectGroupType,
    });
  });

  // 5. Power BI cards
  if (isPowerBICardsEnabled && !_.isEmpty(filteredPowerBICards)) {
    _.forEach(filteredPowerBICards, data => {
      const id = _.get(data, "id", "");
      items.push({
        type: POWER_BI_CARD,
        id,
        data,
      });
    });
  }

  // Order items by user preference
  return getOrderedItems({
    items,
    savedOrder: getModulesAndProjectsOrderPreference(),
  });
};

const getFilteredHomepageFeatures = ({ homepageFeatures, hiddenFeatures }) => {
  return _.filter(homepageFeatures, ({ feature } = {}) => {
    return !_.includes(hiddenFeatures, feature);
  });
};

const getFilteredSamlSpProviderDetails = ({
  samlSpProviderDetails,
  hiddenFeatures,
}) => {
  return _.filter(samlSpProviderDetails, ({ id } = {}) => {
    return !_.includes(hiddenFeatures, id);
  });
};

const getFilteredThirdPartyRedirectUrlData = ({
  thirdPartyRedirectUrlData,
  hiddenFeatures,
}) => {
  return _.filter(
    thirdPartyRedirectUrlData,
    ({ service, redirectUrl, customValue } = {}) => {
      const isValidUrl =
        !_.isEmpty(service) &&
        (!_.isEmpty(redirectUrl) || !_.isEmpty(customValue));

      return isValidUrl && !_.includes(hiddenFeatures, service);
    }
  );
};

const getFilteredPowerBICards = ({ powerBICardsConfig, hiddenFeatures }) => {
  return _.filter(powerBICardsConfig, ({ id, name, url } = {}) => {
    const isValidUrl = !_.isEmpty(name) && !_.isEmpty(url);

    return isValidUrl && !_.includes(hiddenFeatures, id);
  });
};

const getFilteredProjectGroupTypes = ({
  projectGroupTypes,
  hiddenFeatures,
}) => {
  return _.filter(projectGroupTypes, projectGroupType => {
    return !_.includes(hiddenFeatures, projectGroupType);
  });
};

export const getFilteredFeaturesByType = ({
  homepageFeatures = [],
  samlSpProviderDetails = [],
  thirdPartyRedirectUrlData = [],
  projectGroupTypes = [],
  powerBICardsConfig = [],
}) => {
  const {
    HOME_PAGE_FEATURE,
    SAML_SP_PROVIDER,
    THIRD_PARTY_REDIRECT_URL,
    PROJECT_GROUP,
    POWER_BI_CARD,
  } = MODULES_AND_PROJECTS_FEATURES;

  const {
    [HOME_PAGE_FEATURE]: homepageHiddenFeatures,
    [SAML_SP_PROVIDER]: samlSpHiddenProviders,
    [THIRD_PARTY_REDIRECT_URL]: hiddenThirdPartyRedirectUrls,
    [PROJECT_GROUP]: hiddenProjectGroups,
    [POWER_BI_CARD]: hiddenPowerBICards,
  } = getHiddenFeaturesPreference();

  return {
    [HOME_PAGE_FEATURE]: getFilteredHomepageFeatures({
      homepageFeatures,
      hiddenFeatures: homepageHiddenFeatures,
    }),
    [SAML_SP_PROVIDER]: getFilteredSamlSpProviderDetails({
      samlSpProviderDetails,
      hiddenFeatures: samlSpHiddenProviders,
    }),
    [THIRD_PARTY_REDIRECT_URL]: getFilteredThirdPartyRedirectUrlData({
      thirdPartyRedirectUrlData,
      hiddenFeatures: hiddenThirdPartyRedirectUrls,
    }),
    [PROJECT_GROUP]: getFilteredProjectGroupTypes({
      projectGroupTypes,
      hiddenFeatures: hiddenProjectGroups,
    }),
    [POWER_BI_CARD]: getFilteredPowerBICards({
      powerBICardsConfig,
      hiddenFeatures: hiddenPowerBICards,
    }),
  };
};

const _getCustomRegions = ({ organizationTags, userTags }) => {
  if (shouldShowRegionTags({ organizationTags, userTags })) {
    return getUserRegions({ userTags });
  }
  return [];
};
export const getCustomRegions = _.memoize(
  _getCustomRegions,
  ({ organizationTags, userTags }) =>
    JSON.stringify({
      orgTags: _.map(organizationTags, ({ key, value }) => ({ key, value })),
      userTags: _.map(userTags, ({ key, value }) => ({ key, value })),
    })
);

const _getFilteredGrades = ({
  organizationDetails,
  curriculumProgramIds = [],
}) => {
  return _.filter(organizationDetails?.grades, grade =>
    _.includes(curriculumProgramIds, _.get(grade, "curriculumProgram.id", ""))
  );
};
export const getFilteredGrades = _.memoize(
  _getFilteredGrades,
  ({ organizationDetails, curriculumProgramIds }) =>
    JSON.stringify({
      orgCpIds: _.map(organizationDetails?.grades, "curriculumProgram.id"),
      cpIds: curriculumProgramIds,
    })
);

export const announcementsNewCountSelector = state => ({
  newCircularCount: _.get(state, "data.newAnnouncementsCount"),
  unreadCircularCount: _.get(state, "data.unreadAnnouncementsCount"),
});
